import { useState, useEffect } from 'react';
import axiosService from '../../../../service_v2/common/axios-service';

export const useFetchMediaAccess = (active, refresh) => {
  const [mediaAccesssResponse, setMediaAccessResponse] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchMediaAccess = async () => {
      setIsLoading(true);
      setError(null);

      try {
        const response = await axiosService.get(
          `${process.env.REACT_APP_MP_CF_GEN2_API_BASE_URL}qalbox-admin-media-access/v1/get/all?active=${active}&limit=100&page=1`
        );
        setMediaAccessResponse(response?.data);
      } catch (err) {
        console.error(err);
        setError(err.message || 'An error occurred while fetching media access');
      } finally {
        setIsLoading(false);
      }
    };

    fetchMediaAccess();

  }, [active, refresh]); // Fetch media access whenever the 'active' parameter changes

  return [ mediaAccesssResponse, isLoading, error ];
};